import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/sharp-solid-svg-icons';
import type { FC } from 'react';

import { ButtonSize, ButtonVariant } from '@/components/button';
import IconButton from '@/components/button/iconButton';
import Typography from '@/components/typography';

type Props = {
  onClick: () => void;
  title: string;
};

export const PanelContentSwitcher: FC<Props> = ({ title, onClick }) => {
  return (
    <IconButton
      className="flex w-min items-center justify-start gap-3 px-3 py-2"
      size={ButtonSize.MEDIUM}
      variant={ButtonVariant.GHOST}
      onClick={onClick}
    >
      <FontAwesomeIcon className="h-4 w-4" icon={faArrowLeft} />
      <Typography variant="button2">{title}</Typography>
    </IconButton>
  );
};
